import type { RouteObject } from 'react-router'

export const extractRoutePatterns = (routes: RouteObject[], parentPath = '') => {
  let patterns: string[] = []

  routes.forEach((route) => {
    if (route.path) {
      const fullPath = parentPath ? `${parentPath}/${route.path}`.replace(/\/+/g, '/') : route.path

      patterns.push(fullPath)

      if (route.children && route.children.length > 0) {
        patterns = [...patterns, ...extractRoutePatterns(route.children, fullPath)]
      }
    } else if (route.children) {
      patterns = [...patterns, ...extractRoutePatterns(route.children, parentPath)]
    }
  })

  return patterns
}
